var formatDate = function (createdAt: Date) {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const date = new Date(createdAt);
    return date.toLocaleDateString('en-US', options);
}

export default formatDate;
